<script lang="ts">
  let className: string | undefined = undefined;
  export { className as class };
</script>

<svg
  width="1057"
  height="1045"
  viewBox="0 0 1057 1045"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={className}
>
  <path
    d="M142.286 1037.56C182.406 1041.41 282.254 1012.72 347.248 991.032C533.431 928.902 836.515 731.826 1000.92 304.004C1014.91 261.867 1040.36 174.344 1054.61 93.1609C1061.04 56.4739 1027 27.8443 990.953 37.2307C969.201 42.895 953.273 61.3424 949.775 83.546C918.701 280.784 835.723 426.763 791.534 496.633C644.03 751.607 409.649 904.588 221.48 937.324C216.827 938.134 212.111 937.712 207.536 936.542C187.363 931.381 174.342 933.38 158.947 945.28C145.288 955.838 126.85 954.421 114.469 951.994C113.05 951.716 111.515 953.476 111.151 954.875C110.004 959.281 112.732 965.768 117.943 968.383C114.527 968.224 112.159 963.153 111.402 960.637C93.0564 963.533 89.1904 967.96 86.9059 970.857C86.2813 971.648 85.8618 972.592 85.7316 973.592C85.2157 977.554 86.1935 981.825 89.5791 983.949C91.1087 984.908 92.7565 985.624 94.5285 986.143L96.3392 986.597C94.6367 988.269 96.1721 997.535 103.145 1001.99L106.024 1003.73C108.388 1011.11 112.637 1018.16 119.796 1021.12C120.947 1021.6 122.108 1022.02 123.275 1022.38L124.436 1023.42C122.851 1032.13 136.611 1037.02 142.286 1037.56Z"
    fill="url(#paint0_linear_146_775)"
  />
  <path
    d="M116.792 1005.77C112.292 998.678 112.43 990.183 113.061 986.822L121.537 986.182C117.509 992.527 122.421 1002.2 125.381 1006.24L116.792 1005.77Z"
    stroke="currentStroke"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M114.778 966.193L102.657 968.553L116.54 968.036L114.778 966.193Z"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="fill-foreground"
  />
  <path
    d="M124.436 1023.42C122.851 1032.13 136.611 1037.02 142.286 1037.56C182.406 1041.41 282.254 1012.72 347.248 991.032C533.431 928.902 836.515 731.826 1000.92 304.004C1014.91 261.867 1040.36 174.344 1054.61 93.1609C1061.04 56.4739 1027 27.8443 990.953 37.2307V37.2307C969.201 42.8949 953.273 61.3424 949.775 83.546C918.701 280.784 835.723 426.763 791.534 496.633C644.03 751.607 409.649 904.588 221.48 937.324C216.827 938.134 212.111 937.712 207.536 936.542C187.363 931.381 174.342 933.38 158.947 945.28C145.288 955.838 126.85 954.421 114.469 951.994C113.05 951.716 111.515 953.476 111.151 954.875C110.004 959.281 112.732 965.768 117.943 968.383M163.479 1020.56C151.046 1023.65 134.686 1027.29 119.797 1021.12C112.638 1018.16 108.387 1011.11 106.024 1003.73V1003.73M146.246 1003.67C128.831 1007.02 111.907 1007.6 103.145 1001.99C96.1721 997.535 94.6367 988.269 96.3392 986.597M142.247 984.294C117.266 985.287 100.446 990.762 89.5811 983.95C86.1953 981.827 85.2157 977.554 85.7316 973.592V973.592C85.8618 972.592 86.2813 971.648 86.9059 970.856C89.1904 967.961 93.0564 963.533 111.402 960.637M102.656 968.553C111.386 968.936 123.707 970.002 140.555 961.091"
    stroke="url(#paint1_linear_146_775)"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <defs>
    <linearGradient
      id="paint0_linear_146_775"
      x1="224.5"
      y1="970"
      x2="983"
      y2="122.5"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.740028" stop-color="currentColor" />
      <stop offset="1" stop-color="currentColor" />
    </linearGradient>
    <linearGradient
      id="paint1_linear_146_775"
      x1="217.5"
      y1="974.5"
      x2="1013.5"
      y2="125"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.678018" style="stop-color: hsl(var(--color-foreground));" />
      <stop offset="1" stop-color="currentColor" />
    </linearGradient>
  </defs>
</svg>
